import { Component } from "react";
import { LabeledCheckbox } from "./LabeledCheckbox";
import i18n from "../utils/i18n";

class PriceInput extends Component {
  static roundToTwoDecimals(value) {
    return Math.round(value * 100) / 100;
  }

  static checkForMinimumAndMaximum(amount, minimum, maximum) {
    if (amount < minimum) {
      amount = minimum;
    } else if (maximum !== undefined && amount > maximum) {
      amount = maximum;
    }

    return amount;
  }

  static calculateFee(amount, feeOptions) {
    const { percent, flat, minimum, maximum } = feeOptions;
    let fee = 0.0;

    if (flat !== undefined) {
      fee += flat;
    }

    if (percent !== undefined) {
      fee += amount * percent;
    }

    fee = PriceInput.checkForMinimumAndMaximum(fee, minimum, maximum);

    return fee;
  }

  static feeDescription(feeOptions) {
    const result = [];

    if (feeOptions.percent) {
      result.push((feeOptions.percent * 100).toFixed(2) + " %");
    }

    if (feeOptions.flat) {
      result.push(feeOptions.flat.toFixed(2) + " kr.");
    }

    return result.join(" + ");
  }

  constructor(props) {
    super(props);

    const currentValue = (parseFloat(props.value || 0.0) || 0.0).toFixed(2);

    this.state = {
      value: currentValue,
      activated: currentValue > 0.0,
    };
  }

  feeCalculations(amount) {
    const { minimumCharge = 0.0, paymentFee } = this.props;
    const charge = Math.max(amount, minimumCharge);

    return {
      charge: PriceInput.roundToTwoDecimals(charge),
      paymentFeeAmount: PriceInput.calculateFee(charge, paymentFee),
    };
  }

  handleChangeAmount(event) {
    this.setState({ value: event.target.value });
  }

  handleBlurAmount(event) {
    this.sanitizeValue();
  }

  sanitizeValue() {
    const { value } = this.state;
    let amount = parseFloat(value) || 0.0;
    const { charge } = this.feeCalculations(amount);

    if (amount < charge) {
      amount = charge;
    }

    this.setState({ value: amount.toFixed(2) });
  }

  handleChangeActivated(event) {
    this.setState({ activated: event.target.checked });
  }

  render() {
    const { value, activated } = this.state;
    const { inputProps = {}, paymentProviderLink, paymentFee } = this.props;
    const amount = parseFloat(value);
    const { charge, paymentFeeAmount } = this.feeCalculations(amount);
    const helpMessage = {
      __html: i18n.t("components.price_input.total_fee_html", {
        price: charge.toFixed(2),
        payment_fee: paymentFeeAmount.toFixed(2),
        payment_fee_description: PriceInput.feeDescription(paymentFee),
        payment_provider_link: paymentProviderLink,
      }),
    };

    const formValue = activated ? value : 0.0;

    return (
      <div className="form-group">
        <div className="checkbox">
          <LabeledCheckbox
            id="payment_fee_activated_checkbox"
            key="activated"
            checked={activated}
            onChange={(e) => this.handleChangeActivated(e)}
            labelText={i18n.t("components.price_input.has_price")}
          />
        </div>

        <input
          type="hidden"
          name={inputProps.name}
          value={formValue}
          key="formValue"
        />

        {activated && (
          <div>
            <input
              {...inputProps}
              type="text"
              className="form-control"
              id="payment_fee_price"
              key="formInput"
              name={null}
              defaultValue={value}
              onChange={(e) => this.handleChangeAmount(e)}
              onBlur={(e) => this.handleBlurAmount(e)}
            />

            <span
              className="help-block"
              dangerouslySetInnerHTML={helpMessage}
            />
          </div>
        )}
      </div>
    );
  }
}

export default PriceInput;
